import { EMPTY_FIELD } from 'constants/emptyField';

import { CardTable } from 'shared/mui/Card/CardTableNew/CardTable';
import { Chip } from 'shared/mui/Chips';
import { TableProps } from 'shared/mui/Table';
import { TableRowWrapper } from 'shared/mui/Table/TableRowWrapperNew/TableRowWrapper';
import { ChipField, EmbeddedFunctionField, TextField } from 'shared/react-admin/Fields';
import { EmbeddedArrayField } from 'shared/react-admin/Fields/Embedded/EmbeddedArrayField/EmbeddedArrayField';
import { Country } from 'types/embedded/country';
import { User } from 'types/embedded/user';
import { getUserName } from 'utils/getUserName';

export type WorkTeamsShowTableProps = TableProps;

export const WorkTeamsShowTable: React.FC<WorkTeamsShowTableProps> = () => {
  return (
    <CardTable tableBodyProps={{ sx: { '& td': { width: '188px' } } }}>
      <TableRowWrapper label="Группа">
        <TextField source="name" />
      </TableRowWrapper>
      <TableRowWrapper
        contentStyle={{ paddingBottom: '8px' }}
        headerStyle={{ width: '160px' }}
        label="Страны"
      >
        <EmbeddedArrayField
          label="Страны"
          render={(countries: Country[]) =>
            countries.map((country: Country) => (
              <ChipField
                key={country.id}
                record={country}
                source="name"
                sx={{ marginRight: '4px', marginBottom: '4px' }}
              />
            ))
          }
          sortable={false}
          sourceField="countries"
        ></EmbeddedArrayField>
      </TableRowWrapper>
      <TableRowWrapper label="Руководитель группы">
        <EmbeddedFunctionField render={getUserName} sourceField="manager" />
      </TableRowWrapper>
      <TableRowWrapper contentStyle={{ paddingBottom: '8px' }} label="Участники">
        <EmbeddedArrayField
          render={(values: User[]) => {
            return values.map((value) => {
              return (
                <Chip
                  key={value.id}
                  label={`${value?.firstName} ${value?.lastName}`}
                  sx={{ marginRight: '4px', marginBottom: '4px' }}
                />
              );
            });
          }}
          sourceField="members"
        />
      </TableRowWrapper>
      <TableRowWrapper label="Reddy ID канала">
        <TextField emptyText={EMPTY_FIELD} source="reddyChatId" />
      </TableRowWrapper>
    </CardTable>
  );
};
